// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"9460f159","805":"29c40a14"}[chunkId] + ".chunk.css";
};